import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, ButtonDropdown, Modal,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { PIPS_X, SENDPIP4APPROVAL, CANCELIPAAPPROVAL, EMPLOYEES, CONVERT2PA, PIPLINE1, PIPLINE2, SENDPIPREVIEWAPPROVAL, REOPENDOCUMENT} from 'helpers/url_helper';
import * as url from "../../helpers/url_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Timeline from './Timeline';
import Swal from 'sweetalert2';
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const PIPDetails = () => {
        const {id} = useParams();
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [apType , setApType] = useState(['Annual', 'Probation'])

        const [btnprimary1, setBtnprimary1] = useState(false)
        const [rows1, setrows1] = useState([{ id: 1 }]);
        const [th, setTh] = useState(['Customer','Financial','Internal Business Process','Learning and Growth'])
        const [periods , setPeriods] = useState(['January-June', 'July-December'])
        const [inputs, setInputs] = useState([]);

        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')

        const [supervisorNo, setSupervisorNo] = useState('')
        const [supervisorName, setSupervisorName] = useState('')
        const [supervisorTitle, setSupervisorTitle] = useState('')

        const [pipLines1, setPipLines1] = useState([])
        const [pipLines2, setPipLines2] = useState([])

        const [startDate, setStartDate] = useState(new Date());
        const [endDate, setEndDate] = useState(new Date());
        const [type, setType] = useState('');

        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaNo, setIpaNo] = useState('')
        const [ipaStatus, setIpaStatus] = useState('')
        const [ipaDate, setIpaDate] = useState('')
        const [ipaPerformanceYear, setIpaPerformanceYear] = useState('')
        const [ipaConvert, setIpaConvert] = useState('')
        const [appraisalPeriod, setAppraisalPeriod] = useState('')
        const [documentType, setDocumentType] = useState('')
        const [performanceType, setPerformanceType] = useState('')
        const [departmentCode, setDepartmentCode] = useState('')
        const [stage, setStage] = useState('')
        const [pipphase, setPIPPhase] = useState('')
        const [lines, setLines] = useState([])
        const [st, setSt] = useState(0)
        const [isEdit, setIsEdit] = useState(false)
        const [lineSystemId, setLineSystemId] = useState('')
        const [documentid, setDocumentId] = useState('')

        const [kra, setKra] = useState('')
        const [target, setTarget] = useState('')
        const [kpi, setKpi] = useState('')
        const [resources, setResources] = useState('')

        const [cCode, setCCode] = useState('')
        const [competenciesDescription, setCompetenciesDescription] = useState('')
        const [attributes, setAttributes] = useState('')
        const [kpi2, setKpi2] = useState('')
        const [resources2, setResources2] = useState('')

        const [support, setSupport] = useState('')
        const [plannedResults, setPlannedResults] = useState('')
        const [actualResults, setActualResults] = useState('')

        const [goal, setGoal] = useState('')
        const [method, setMethod] = useState('')
        const [application, setApplication] = useState('')
        const [competencies, setCompetencies] = useState([])
        
        const [modal_ipa1, setmodal_ipa1] = useState(false)
        const [modal_ipa2, setmodal_ipa2] = useState(false)
        const [modal_ipa3, setmodal_ipa3] = useState(false)
        const [modal_ipa4, setmodal_ipa4] = useState(false)

        const [CompanyID, setCompanyID] = useState("")

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_ipa1 = () => {
            setmodal_ipa1(!modal_ipa1);
            removeBodyCss();
        }
        const tog_ipa2 = () => {
            setmodal_ipa2(!modal_ipa2);
            removeBodyCss();
        }
        const tog_ipa3 = () => {
            setmodal_ipa3(!modal_ipa3);
            removeBodyCss();
        }
        const tog_ipa4 = () => {
            setmodal_ipa4(!modal_ipa4);
            removeBodyCss();
        }
       
        const clearData1 = () =>{
            setIsEdit(false)
            setKra('')
            setTarget('')
            setKpi('')
            setResources('')
            setLineSystemId('')
        }
        const clearData2 = () =>{
            setIsEdit(false)
            setCCode('')
            setAttributes('')
            setKpi2('')
            setResources2('')
            setLineSystemId('')
        }
        const clearData3 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setSupport('')
            setPlannedResults('')
            setActualResults('')
        }
        const clearData4 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setGoal('')
            setMethod('')
            setApplication('')
        }
    
        const addIPA1 = () =>{
            setIsloading(true)
            if(isEdit){
                const Config = {
                    auth: {
                      username: url.HRMIS,
                      password: url.HRMISPASS,
                    },
                    headers: {
                      'Content-Type': 'application/json',
                      'If-Match'    : '*'
                    }
                }
                const data = {
                    "KeyResultArea": kra,
                    "StatementofTargettobeachieved": target,
                    "KeyPerformanceIndicator": kpi,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources
                }           
                axios.patch(`${PIPLINE1}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                    setIsloading(false)
                    toastr.success('PIP line 1 updated')
                    tog_ipa1()
                    clearData1()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }else{
                const data = {
                    "DocumentNo": ipaNo,
                    "KeyResultArea": kra,
                    "StatementofTargettobeachieved": target,
                    "KeyPerformanceIndicator": kpi,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources
                }           
                axios.post(`${PIPLINE1}?company='${CompanyID}'`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsloading(false)
                    toastr.success('PIP line 1 added')
                    tog_ipa1()
                    clearData1()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
            
        }
        const remove1 = ()=>{

            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PIPLINE1}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PIP line 1 removed')
                tog_ipa1()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const addIPA2 = () =>{
         
            setIsloading(true)
            if(isEdit){
                const Config = {
                    auth: {
                      username: url.HRMIS,
                      password: url.HRMISPASS,
                    },
                    headers: {
                      'Content-Type': 'application/json',
                      'If-Match'    : '*'
                    }
                }
                const data = {
                    "CompetenceCode": cCode,
                    //"competenciesDescription": competenciesDescription,
                    "CriticalAttributestargetedundereachcompetence": attributes,
                    "KeyPerformanceIndicator": kpi2,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources2
                }           
                axios.patch(`${PIPLINE2}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                    setIsloading(false)
                    toastr.success('PIP line 2 updated')
                    tog_ipa2()
                    clearData2()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }else{
                const data = {
                    "DocumentNo": ipaNo,
                    "CompetenceCode": cCode,
                    "CriticalAttributestargetedundereachcompetence": attributes,
                    "KeyPerformanceIndicator": kpi2,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources2
                }   
                console.log(JSON.stringify(data)) 
                console.log(`${PIPLINE2}`)       
                axios.post(`${PIPLINE2}?company=${CompanyID}`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsloading(false)
                    console.log(r)
                    toastr.success('PIP line 2 added')
                    tog_ipa2()
                    clearData2()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
            
        }
        const remove2 = ()=>{
            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PIPLINE2}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PIP line 2 removed')
                tog_ipa2()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        
        const handleClickLineDetails1 = (k) =>{
            setIsEdit(true)
            tog_ipa1()
            setKra(pipLines1[k].KeyResultArea)
            setTarget(pipLines1[k].StatementofTargettobeachieved)
            setKpi(pipLines1[k].KeyPerformanceIndicator)
            setResources(pipLines1[k].ResourcesandSupportRequiredforachievementsettargetsandgoals)
            setLineSystemId(pipLines1[k].SystemId)
        }
        const handleClickLineDetails2 = (k) =>{
            setLineSystemId(pipLines2[k].SystemId)
            setIsEdit(true)
            tog_ipa2()
            setCCode(pipLines2[k].CompetenceCode)
            setAttributes(pipLines2[k].CriticalAttributestargetedundereachcompetence)
            setKpi2(pipLines2[k].KeyPerformanceIndicator)
            setResources2(pipLines2[k].ResourcesandSupportRequiredforachievementsettargetsandgoals)
        }
        
        const fetchData = () => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(url.PIPS_X + "("+ id +")?$expand=pipLines,pipLines2&company="+ obj.activeCompany, HRConfig)
            .then(function(response){
                    
                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.EmployeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{ 
                        setEmpName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setEmpTitle(r.data.value[0].JobTitle)
                        setIsloading(false)
                    }).catch((e)=>{ console.log(e) })
                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.Appraiser}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{ 
                        setSupervisorName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setSupervisorTitle(r.data.value[0].JobTitle)
                        setIsloading(false)
                    }).catch((e)=>{ console.log(e) })
                    setEmpNo(response.data.EmployeeNo)
                    
                    setSupervisorNo(response.data.Appraiser)
                    setDepartmentCode(response.data.DepartmentCode)
                    setIpaDate(response.data.PostingDate)
                    setIpaPerformanceYear(response.data.PerformanceYear)
                    setIpaStatus(response.data.Status)
                    setIpaConvert(response.data.ConvertToAppraisal)
                    setAppraisalPeriod(response.data.AppraisalPeriod)
                    setIpaNo(response.data.No)
                    setPIPPhase(response.data.PIPPhase)
                    setDocumentType(response.data.DocumentType)
                    setPerformanceType(response.data.PerformanceType)
                    setStage(response.data.Stage)
                    setStartDate(response.data.FromDate)
                    setEndDate(response.data.ToDate)
                    setType(response.data.TypeofPerformanceAppraisal)
                    setPipLines1(response.data.pipLines)
                    setPipLines2(response.data.pipLines2)
                    if(response.data.Status == 'Open'){
                        setSt(5);
                    }else if(response.data.Status == 'Pending Approval'){
                        setSt(5);
                    }
                   
                    
                }).catch(function (error) {
                    setUserError(true);
                    setIsloading(false)
                    console.log(error)
                })
                axios.get(url.COMPETENCIES +"?company="+ obj.activeCompany, HRConfig).then((r)=>{ setCompetencies(r.data.value);  }).catch((e)=>{ console.log(e) })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const handleDeleteIPA = () =>{
            Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to recover this PIP',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel',
              }).then((result) => {
                if (result.isConfirmed) {
                    setIsloading(true)
                    const Config = {
                        auth: {
                          username: url.HRMIS,
                          password: url.HRMISPASS,
                        },
                        headers: {
                          'Content-Type': 'application/json',
                          'If-Match'    : '*'
                        }
                    }
                    axios.delete(`${PIPS_X}(${id})?company=${CompanyID}`, Config).then((r)=>{
                        setIsloading(false)
                        Swal.fire('Deleted!', 'PIP has been deleted.', 'success');
                        history.push("/performance-improvement-plans")
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                  
                }
              });
            
        }

        const handleSendForApproval = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(SENDPIP4APPROVAL+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success(response.data.value ); 
                        fetchData()
                    }else{
                        toastr.success("Could not Post PIP" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                // always executed
                setIsloading(false)
            });
        }
        const handleSendForReview = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(SENDPIPREVIEWAPPROVAL+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success(response.data.value ); 
                        fetchData()
                    }else{
                        toastr.success("Could not send PIP for review" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                setIsloading(false)
            });
        }
        const handleCancelApproval = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(CANCELIPAAPPROVAL+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){      
                    if(response.status == '200'){
                        toastr.success(response.data.value); 
                        fetchData()
                    }else{
                        toastr.success("Could not Cancel Approval Request" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }

        const handleConverToAppraisal = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(CONVERT2PA +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    //console.log(response)  
                    if(response.status == '204'){
                        toastr.success(response.data.value); 
                        history.push("/performance-appraisals");
                    }else{
                        toastr.success("Could not Convert To Performance Appraisal" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
            });
        }

        const handleFillAppraisal = () =>{
            history.push("/performance-appraisals");
        }


        const [formRows, setFormRows] = useState([{ id: 1 }]);

        return (
            <LoadingOverlay
            active={isloading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
            <MetaTags>
            <title>PIP Details | BRIDGE</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title="Performance Management" breadcrumbItem="Performance Improvement Plans" />
                <div>


                            <Modal isOpen={modal_ipa1} toggle={tog_ipa1} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update `:`Add `} Technical Job Deliverables</h5>
                                    <button type="button" onClick={() => { setmodal_ipa1(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Result Area</label>
                                                <textarea className="form-control" value={kra} onChange={(e)=>setKra(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Statement of target to be achieved</label>
                                                <textarea className="form-control" value={target} onChange={(e)=>setTarget(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea className="form-control" value={kpi} onChange={(e)=>setKpi(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Resources Required</label>
                                                <textarea className="form-control" value={resources} onChange={(e)=>setResources(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa1() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    {isEdit && <button type="button" className="btn btn-dark" onClick={remove1}>Delete Line...</button>}
                                    <button type="button" className="btn btn-success" onClick={addIPA1}>Save Line...</button>
                                  </div>
                                  )}
                                </Modal>
                                <Modal isOpen={modal_ipa2} toggle={tog_ipa2} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update `:`Add `} Competence Targets</h5>
                                    <button type="button" onClick={() => { setmodal_ipa2(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Competence Code</label>
                                                <select className="form-select" value={cCode} onChange={(e)=>setCCode(e.target.value)}>
                                                    <option value=""></option>
                                                    {competencies.map((c,k)=>(
                                                        <option key={k} value={c.code}>{c.codeDescription}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        {/*<Col md={12}>
                                            <div className="mb-3">
                                                <label>Description</label>
                                                <textarea className="form-control" value={competenciesDescription} onChange={(e)=>setCompetenciesDescription(e.target.value)} />
                                            </div>
                                        </Col>*/}
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Critical Attributes Targeted</label>
                                                <textarea className="form-control" value={attributes} onChange={(e)=>setAttributes(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea className="form-control" value={kpi2} onChange={(e)=>setKpi2(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Resources Required</label>
                                                <textarea className="form-control" value={resources2} onChange={(e)=>setResources2(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa2() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    {isEdit && <button type="button" className="btn btn-dark" onClick={remove2}>Delete Line...</button>}
                                    <button type="button" className="btn btn-success" onClick={addIPA2}>Save Line...</button>
                                  </div>
                                  )}
                                </Modal>
                
                <Row>
                <Col  xl={3}>
                            <Timeline stage={st}/>
                            {(ipaStatus == 'Open') && (
                                <Card>
                                    <CardBody>
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Performance Improvement Plan Actions</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                        <div className="d-grid">
                  
                                            <ButtonDropdown
                                                isOpen={btnprimary1}
                                                toggle={() => setBtnprimary1(!btnprimary1)}
                                                >
                                                <DropdownToggle tag="button" className="btn btn-primary">
                                                    + Add Deliverables <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                
                                                <DropdownMenu>
                                                    <DropdownItem onClick={()=>{ tog_ipa1(); clearData1();}}>Add Technical Job Deliverables</DropdownItem>
                                                    <DropdownItem onClick={()=>{ tog_ipa2(); clearData2();}}>Add Competence Targets</DropdownItem> 
                                                </DropdownMenu>
                                            
                                            </ButtonDropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                                </Card>
                            )}

                        </Col>
                        <Col xl={9}>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                       
                                    <Row>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee No</label>
                                            <input type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                        </div>
                                    </Col>
                                   
                              
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorName} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorTitle}  />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">PIP Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                                <Row>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>No</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaNo}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Department Code</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={departmentCode}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Type</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={performanceType}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Year</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaPerformanceYear}  />
                                        </div>
                                </Col>
                                {<Col md={4}>
                                        <div className="mb-3">
                                            <label>PIP Stage</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={pipphase}  />
                                        </div>
                                </Col>}
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaStatus}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Posting Date</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaDate}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Start Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            value={new Date(startDate)}
                                            onChange={(date)=>setStartDate(date)}
                                        />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>End Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            value={new Date(endDate)}
                                            onChange={(date)=>setEndDate(date)}
                                        />
                                        </div>
                                    </Col>
                                    
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Technical Job Deliverables ({pipLines1.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(pipLines1.map((i,k)=>(
                                        <Row key={k} className='justify-content-center align-items-center'>
                                            <Col lg={7}>
                                            
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Result Area: </strong><br/>{i.KeyResultArea}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Statement of target to be achieved: </strong><br/>{i.StatementofTargettobeachieved} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={5} className="mb-3">
                                            <h5>&nbsp;</h5>
                                            <p className="mb-1">
                                                <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                <strong>Resources and support required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                            </p>
                                            {(pipphase == 'PIP Performance Review') && ( 
                                            <Row className='justify-content-center'>
                                                <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               {/* <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                                </Row> */}
                                            </Row>
                                            
                                            )} 
                                            {(pipphase == 'PIP Target Setting') && (ipaStatus == 'Approved')&& ( 
                                            <Row className='justify-content-center'>
                                                <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               {/* <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                            </Row> */}
                                            </Row>
                                            
                                            )} 
                                            {(ipaStatus == 'Open') && (pipphase == 'PIP Target Setting') && (
                                                <Col sm={6} className='mb-3'>
                                                    <div className="float-sm-end d-flex align-items-center">
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded"
                                                                onClick={()=>handleClickLineDetails1(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                    </div>
                                                </Col>
                                                
                                            )} 
                                        </Col> 
                                        <hr/>
                                        </Row>
                                        
                                        
                                    )))}
                          
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Competence Targets ({pipLines2.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(pipLines2.map((i,k)=>(
                                        <Row key={k} className='justify-content-center align-items-center'>
                                            <Col lg={7}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Competence Code: </strong><br/>{i.CompetenceCode} 
                                                    </p>   
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Description: </strong><br/>{i.competenciesDescription} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Critical Attributes Targeted: </strong><br/>{i.CriticalAttributestargetedundereachcompetence}
                                                    </p>

                                                    </div>
                                                </div>
                                            </Col>
                                        <Col lg={5} className="mb-3">
                                            <h5>&nbsp;</h5>
                                            <p className="mb-1">
                                                <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                            </p>
                                            <p className="mb-1">
                                                <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                <strong>Resources and support required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                            </p>
                                            {(pipphase == 'PIP Performance Review') && ( 
                                            <Row className='justify-content-center'>
                                                <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               {/* <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                            </Row> */}
                                            </Row>
                                            )}
                                            {(pipphase == 'PIP Target Setting') && (ipaStatus == 'Approved') && ( 
                                            <Row className='justify-content-center'>
                                                <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               {/* <Row  className="m-1 mb-3">
                                                  <Col sm={12}><h5 className="text-primary">PIP Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                            </Row> */}
                                            </Row>
                                            )}  
                                            {(ipaStatus == 'Open') &&(pipphase == 'PIP Target Setting') && (
                                                <Col sm={6} className='mb-3'>
                                                    <div className="float-sm-end d-flex align-items-center">
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded"
                                                                onClick={()=>handleClickLineDetails2(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                    </div>
                                                </Col>
                                            )}
                                        </Col>                                          
                                            <hr/> 
                                        </Row>
                                    )))}
                                    </CardBody>
                                    </Card>
                                    </Col>
                    
                                <Col md={3}></Col>
                                <Col md={9}>
                                <Row className='justify-content-center align-items-center'>
                                    <Col md={5} className='mb-3'>
                                        <div className="d-grid gap-2">
                                        {(ipaStatus == 'Open') && (
                                            <input
                                                type="button"
                                                className="btn btn-success mt-3 mt-lg-0"
                                                value="Send For Approval"
                                                onClick={handleSendForApproval}
                                            />
                                        ) }
                                        {(ipaStatus == 'Pending Approval') && (
                                            <input
                                                type="button"
                                                className="btn btn-danger mt-3 mt-lg-0"
                                                value="Cancel Approval Request"
                                                onClick={handleCancelApproval}
                                            />
                                        ) }
                                        </div>
                                    </Col>
                                    
                                    {(ipaStatus == 'Open') && (
                                        <Col md={5} className='mb-3'>
                                        <div className="d-grid gap-2">
                                            <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleDeleteIPA} >
                                                Delete PIP
                                            </Button>
                                        </div>
                                        </Col>
                                    ) }
                                    
                                    </Row>

                                    <Row className='justify-content-center align-items-center'>
                                    <Col md={5} className='mb-3'>
                                    {((ipaStatus == 'Approved') && (pipphase == 'PIP Target Setting')) && (
                                        <div className="d-grid gap-2">
                                            <Button color="warning" type="button" className="btn" onClick={handleSendForReview} >
                                                Submit PIP for Review
                                            </Button>
                                        </div>
                                    ) }
                                    {((ipaStatus == 'Approved') && (ipaConvert == 'Yes')) && (
                                        <div className="d-grid gap-2">
                                            <Button color="secondary" type="button" className="btn" onClick={handleFillAppraisal} >
                                                Fill Performance Appraisal Form
                                            </Button>
                                        </div>
                                    ) }
                                    </Col>
                                    </Row>
                                    
      
                                   
            
                </Col>
                </Row>

                </div>


                
                   

            </Container>
        </div>
        </LoadingOverlay>
        );
    }

export default PIPDetails;